import { dialog_children } from "dependencies/dialog/index.js"
export default {
  name: "弹框",
  id: "",
  type: "cxDialog",
  children: dialog_children,
  sort: 80
}
